export type IndirectClassType<T> = { new (...args: any[]): T };
export class IndirectFactory {
    public static create<T>(type: IndirectClassType<T>, ...args: any[]): T {
        return new type(args);
    }
}
